import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Divider,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { LoadingButton } from "../../components";

export default function VerificationLimitDialog({ retryPopUp, setRetryPopUp }) {
  const [loading, setLoading] = useState(false);
  const handleTryDifferentId = () => {
    setLoading(true);
    window.location.reload();
  };

  return (
    <Dialog open={retryPopUp} maxWidth="xs" fullWidth>
      <Box textAlign="center" mt={2}>
        <WarningAmberIcon sx={{ fontSize: 40, color: "error.main" }} />
      </Box>

      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "1.2rem",
        }}
      >
        Verification Attempts Exceeded
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" align="center" mb={2}>
          We’ve detected multiple unsuccessful verification attempts with your
          ID. Don’t worry – this is a security measure to protect your account.
        </Typography>

        <Box
          sx={{
            bgcolor: "#fdecea",
            p: 2,
            borderRadius: 2,
          }}
        >
          <ul style={{ margin: 0, paddingLeft: "1.2rem", color: "#d32f2f" }}>
            <li>
              <b>3 unsuccessful verification attempts</b> have been made with
              this ID
            </li>
            <li>
              Please try again using another government-issued ID, such as a
              Driving License or Passport
            </li>
            <li>
              Further attempts with the same ID may result in temporary
              restrictions
            </li>
          </ul>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", gap: 2, p: 2 }}>
        <LoadingButton
          fullWidth
          variant="contained"
          sx={{ bgcolor: "#f59e0b", "&:hover": { bgcolor: "#d97706" } }}
          onClick={handleTryDifferentId}
          loading={loading}
        >
          Try Different ID
        </LoadingButton>
      </DialogActions>

      <Divider />
      <Typography
        variant="caption"
        align="center"
        display="block"
        sx={{ p: 2, color: "text.secondary" }}
      >
        Security is our priority. Thank you for your patience.
      </Typography>
    </Dialog>
  );
}
